import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextInputField from '../inputs/TextInputField';
import { RootState } from '../../../../redux/store';
import AddMoreButton from '../inputs/AddMoreButton';

export default function NearbyLocation({
  nearbyLocationsEn,
  nearbyLocationsAr,
  handleNearbyLocations,
}) {
  const dispatch = useDispatch();
  // Handle change for Location Name (English or Arabic)
  const handleLocationNameChange = (e, locationIndex, index, language) => {
    dispatch(
      handleNearbyLocations({
        language,
        actionType: 'AddLocationName',
        index,
        locationIndex,
        value: e.target.value,
      }),
    );
  };
  // Handle change for Time Needed (English or Arabic)
  const handleLocationTimeChange = (e, locationIndex, index, language) => {
    dispatch(
      handleNearbyLocations({
        language,
        actionType: 'AddLocationTime',
        index,
        locationIndex,
        value: e.target.value,
      }),
    );
  };

  // Add Location (English or Arabic)
  const handleAddLocation = (index, language) => {
    dispatch(
      handleNearbyLocations({
        language,
        actionType: 'AddLocation',
        index,
      }),
    );
  };

  // Remove Location (English or Arabic)
  const handleRemoveLocation = (index, locationIndex, language) => {
    dispatch(
      handleNearbyLocations({
        language,
        actionType: 'RemoveLocation',
        index,
        locationIndex,
      }),
    );
  };

  // Remove Method (English or Arabic)
  const handleRemoveMethod = (index, language) => {
    dispatch(
      handleNearbyLocations({
        language,
        actionType: 'RemoveMethod',
        index,
      }),
    );
  };

  // Add Method (English or Arabic)
  const handleAddMethod = (language) => {
    dispatch(
      handleNearbyLocations({
        language,
        actionType: 'AddMethod',
      }),
    );
  };

  // Add Method Name (English or Arabic)
  const handleAddMethodName = (e, index, language) => {
    dispatch(
      handleNearbyLocations({
        language,
        actionType: 'AddMethodName',
        index,
        value: e.target.value,
      }),
    );
  };

  // Function to render the fields for a given language
  const renderNearbyLocations = (nearbyLocations, language) => {
    return nearbyLocations?.map((location, index) => (
      <div key={index} className="mb-4 d-flex flex-column">
        <TextInputField
          label={language === 'en' ? 'Method Name' : 'اسم الطريقة'}
          fieldName={`method-name-${index}`}
          value={location.title}
          onInputChange={(e) => handleAddMethodName(e, index, language)}
          config={{ lang: language }}
        />

        {location.items.map((item, locationIndex) => (
          <div className="d-flex flex-column" key={locationIndex}>
            <div key={locationIndex} className="d-flex align-items-center">
              <TextInputField
                label={
                  language === 'en'
                    ? `Location Name #${locationIndex + 1}`
                    : `اسم الموقع #${locationIndex + 1}`
                }
                fieldName={`location-name-${locationIndex}`}
                value={item.locationName}
                onInputChange={(e) =>
                  handleLocationNameChange(e, locationIndex, index, language)
                }
                config={{ lang: language }}
              />

              <TextInputField
                label={
                  language === 'en'
                    ? `Time Needed #${locationIndex + 1}`
                    : `الوقت المطلوب #${locationIndex + 1}`
                }
                fieldName={`needed-time-${locationIndex}`}
                value={item.neededTime}
                onInputChange={(e) =>
                  handleLocationTimeChange(e, locationIndex, index, language)
                }
                config={{ lang: language }}
              />
            </div>
            {language === 'ar' ? (
              <button
                className="btn btn-danger my-3 custom_button_desktop"
                onClick={() =>
                  handleRemoveLocation(index, locationIndex, language)
                }
              >
                Remove
              </button>
            ) : (
              <div className="my-3 remove_button_height" />
            )}
          </div>
        ))}

        {language === 'ar' ? (
          <div className="remove_button_height custom_nearby_add_button_desktop">
            <AddMoreButton
              handleAddItem={() => handleAddLocation(index, language)}
            />
          </div>
        ) : (
          <div className="remove_button_height" />
        )}

        {language === 'ar' ? (
          <button
            className="btn btn-danger mt-2 remove_button_height custom_nearby_button_desktop"
            onClick={() => handleRemoveMethod(index, language)}
          >
            Remove Method
          </button>
        ) : (
          <div className="mt-2 remove_button_height" />
        )}
      </div>
    ));
  };

  return (
    <div>
      <h3>{'Nearby Locations'}</h3>
      <div className="row">
        {/* English Section */}
        <div className="col-md-6">
          <h4>{'English'}</h4>
          {renderNearbyLocations(nearbyLocationsEn, 'en')}

          {/* <AddMoreButton handleAddItem={() => handleAddMethod('en')} /> */}
        </div>

        {/* Arabic Section */}
        <div className="col-md-6" dir="rtl">
          <h4>{'Arabic'}</h4>
          {renderNearbyLocations(nearbyLocationsAr, 'ar')}
        </div>
        <AddMoreButton handleAddItem={() => handleAddMethod('ar')} />
      </div>
    </div>
  );
}
